import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetCarePlanMedicalNotes } from '../types';

const onGetCarePlanMedicalNotes: IThunkGetCarePlanMedicalNotes = thunk(
  // @ts-ignore
  async ({ setCarePlanMedicalNote }, patientId) => {
    const { data } = await api.carePlanMedicalNotes.getList(patientId);
    setCarePlanMedicalNote(data);
  },
);

export default onGetCarePlanMedicalNotes;
